import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Flame, Zap } from "lucide-react";
import api from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import { useContent } from "../context/ContentContext";
import { ProductCard } from "../components/ProductCard";

const BANNER = "https://images.unsplash.com/photo-1774989284270-df2f40b44606";

export default function MonsterShirts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { settings, loaded } = useSettings();
  const { content: c } = useContent();
  const banner = settings.monster_banner_image || (loaded ? BANNER : null);

  useEffect(() => {
    api.get("/products", { params: { category: "monster-shirts" } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="monster-shirts-page">
      {/* LIMITED DROP BANNER */}
      <section className="relative overflow-hidden border-b border-zinc-800 bg-zinc-950 min-h-[45vh] flex" data-testid="monster-drop-banner">
        {banner && <motion.img key={banner} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} src={banner} alt="Monster Shirts" className="w-full h-auto block" />}
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-[1400px] mx-auto px-6 w-full">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <div className="inline-flex items-center gap-2 bg-[#FF3B30] text-white text-xs font-bold uppercase tracking-[0.3em] px-4 py-2 mb-3 sm:mb-5">
              <Flame size={14} /> {c.ms_tag}
            </div>
            <h1 className="font-display text-4xl sm:text-6xl md:text-8xl uppercase leading-[0.9] tracking-tighter max-w-4xl">
              {c.ms_title_prefix} <span className="text-[#FF3B30]">{c.ms_title_highlight}</span>
            </h1>
            <p className="mt-3 sm:mt-6 text-zinc-300 text-sm sm:text-lg max-w-2xl leading-relaxed hidden sm:block">
              {c.ms_subtitle}
            </p>
            <div className="mt-3 sm:mt-6 flex items-center gap-2 text-[#EAB308] text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em]">
              <Zap size={14} /> {c.ms_stock_note}
            </div>
          </motion.div>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 py-12">
        <div className="flex items-end justify-between mb-8">
          <h2 className="font-display text-4xl uppercase tracking-tight">{c.ms_section_prefix} <span className="text-[#FF3B30]">{c.ms_section_highlight}</span></h2>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{products.length} designs</span>
        </div>

        {loading ? (
          <div className="text-zinc-500 py-20 text-center">Loading the drop…</div>
        ) : products.length === 0 ? (
          <div className="text-zinc-500 py-20 text-center">The next Monster Shirts drop is coming soon.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="monster-shirts-grid">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
